export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x3EC2d5af936bBB57DD19C292BAfb89da0E377F42",
  capRiskStewardFactory: "0x93c233008971E878d60a7737657869ab746f3208",
  edgeFactory: "0xA969B8a46166B135fD5AC533AdC28c816E1659Bd",
  edgeFactoryPerspective: "0x8c7543f83D3d295F68447792581F73d7d5D4d788",
  escrowedCollateralPerspective: "0x4e58BBEa423c4B9A2Fc7b8E58F5499f9927fADdE",
  eulerEarnFactoryPerspective: "0xA45895144F2b6E7E6D2fCAFfe6eA19E86aa1667E",
  eulerEarnGovernedPerspective: "0x492e9FE1289d43F8bB6275237BF16c9248C74D44",
  eulerEarnPublicAllocator: "0x8fdCb80a2894F0dC052c8d52D22544DC90274800",
  eulerUngoverned0xPerspective: "0xb50a07C2B0F128Faa065bD18Ea2091F5da5e7FbF",
  eulerUngovernedNzxPerspective: "0x600bBe1D0759F380Fea72B2e9B2B6DCb4A21B507",
  evkFactoryPerspective: "0xB30f23bc5F93F097B3A699f71B0b1718Fc82e182",
  externalVaultRegistry: "0xB3b30ffb54082CB861B17DfBE459370d1Cc219AC",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0xFcd3Db06EA814eB21C84304fC7F90798C00D1e32",
  feeFlowControllerUtil: "0x653eD9b915c7e7C413e7b2a2B6d83dFe02dd36DF",
  fixedCyclicalBinaryIRMFactory: "0xa8F8E82C9Da15A991D7BF2486aE26e22743aC8d0",
  governedPerspective: "0xC0121817FF224a018840e4D15a864747d36e6Eb2",
  governorAccessControlEmergencyFactory:
    "0x025C8831c6E45420DF8E71F7B6b99F733D120Faf",
  irmRegistry: "0x0a64670763777E59898AE28d6ACb7f2062BF459C",
  kinkIRMFactory: "0xcAe0A39B45Ee9C3213f64392FA6DF30CE034C9F9",
  kinkyIRMFactory: "0x010102daAB6133d4f8cEB4C8842a70B9899Fc102",
  oracleAdapterRegistry: "0xA084A7F49723E3cc5722E052CF7fce910E7C5Fe6",
  oracleRouterFactory: "0x70B3f6F61b7Bf237DF04589DdAA842121072326A",
  swapVerifier: "0xae26485ACDDeFd486Fe9ad7C2b34169d360737c7",
  swapper: "0x2Bba09866b6F1025258542478C39720A09B728bF",
  termsOfUseSigner: "0x9ba11Acd88B79b657BDbD00B6dE759718AaAdCbA",
} as const
